import React from 'react';
import { motion } from 'framer-motion';
import { WalletIcon, HeartHandshakeIcon, BoxIcon } from 'lucide-react';
export function MegapackDiff() {
  const extras: {
    num: string;
    title: string;
    desc: string;
    Icon: BoxIcon;
  }[] = [{
    num: 'T7',
    title: 'Cómo hablar de plata sin que se corte la relación',
    desc: 'Cómo presentar presupuestos, manejar el "es muy caro", financiar tratamientos costosos y hablar de dinero con el propietario sin incomodidad ni culpa. Incluye plantilla de presupuesto profesional lista para usar.',
    Icon: WalletIcon
  }, {
    num: 'T8',
    title: 'El propietario emocionalmente desbordado',
    desc: 'Protocolo CONTENER de 7 pasos para contener al dueño que llora, se enoja o entra en pánico — y poder seguir siendo el profesional que su paciente necesita. El tomo más humano de toda la colección.',
    Icon: HeartHandshakeIcon
  }];
  return <section className="bg-navy py-10 sm:py-16 px-5" data-id="element-158">
      <div className="max-w-6xl mx-auto" data-id="element-159">
        <div className="text-center text-[10px] sm:text-xs font-semibold tracking-[0.14em] uppercase text-gold-light mb-2 sm:mb-3" data-id="element-160">
          ¿Qué agrega el Megapack Pro?
        </div>
        <h2 className="font-display text-2xl sm:text-4xl lg:text-5xl font-bold text-center text-white mb-8 sm:mb-12 leading-tight" data-id="element-161">
          Para veterinarios que quieren el sistema completo
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-0.5 max-w-4xl mx-auto rounded-xl sm:rounded-2xl overflow-hidden mb-8 sm:mb-12" data-id="element-162">
          <div className="bg-white/[0.04] p-5 sm:p-7" data-id="element-163">
            <h4 className="text-[10px] sm:text-xs font-bold uppercase tracking-wider text-white/40 mb-3 sm:mb-4" data-id="element-164">
              Sin Megapack Pro
            </h4>
            <p className="text-[11px] sm:text-sm text-white/75 leading-relaxed" data-id="element-165">
              Sabés manejar las conversaciones clínicas pero todavía te incomoda
              hablar de dinero — bajás precios que no tendrías que bajar y no
              sabés cómo contener a un propietario que se desborda
              emocionalmente.
            </p>
          </div>
          <div className="bg-green-light/20 p-5 sm:p-7 border-l-[3px] border-green-light" data-id="element-166">
            <h4 className="text-[10px] sm:text-xs font-bold uppercase tracking-wider text-green-light mb-3 sm:mb-4" data-id="element-167">
              Con Megapack Pro
            </h4>
            <p className="text-[11px] sm:text-sm text-white/75 leading-relaxed" data-id="element-168">
              Tenés el protocolo completo para presentar presupuestos con
              confianza, negociar sin culpa, y contener al propietario que
              llora, se enoja o entra en pánico — y seguir siendo el profesional
              que su paciente necesita.
            </p>
          </div>
        </div>

        <div className="max-w-4xl mx-auto space-y-3 sm:space-y-4" data-id="element-169">
          {extras.map((extra, i) => <motion.div key={i} whileTap={{
          scale: 0.98
        }} className="bg-white/6 border border-white/10 rounded-xl p-4 sm:p-7 flex gap-3 sm:gap-5 items-start cursor-default" data-id="element-170">
              <div className="bg-gold w-10 h-10 sm:w-12 sm:h-12 rounded-lg flex items-center justify-center flex-shrink-0 relative" data-id="element-171">
                <extra.Icon className="w-5 h-5 sm:w-6 sm:h-6 text-navy" strokeWidth={2} data-id="element-172" />
                <span className="absolute -top-1.5 -right-1.5 bg-navy text-gold-light text-[8px] sm:text-[9px] font-bold px-1 py-0.5 rounded" data-id="element-173">
                  {extra.num}
                </span>
              </div>
              <div data-id="element-174">
                <h4 className="font-semibold text-sm sm:text-base text-white mb-1 sm:mb-1.5" data-id="element-175">
                  {extra.title}
                </h4>
                <p className="text-[11px] sm:text-sm text-white/65 leading-relaxed" data-id="element-176">
                  {extra.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}